// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable no-restricted-imports */
// @ts-expect-error: Flow to TS migration.
import fp from "lodash/fp"
// FIXME: immutable is treated as "any" because of .flowconfig
// @ts-expect-error: Flow to TS migration.
import type { Map, RecordOf } from "immutable"
// @ts-expect-error: Flow to TS migration.
import { createSelector, InputSelector, OutputSelector } from "reselect"

import type { PassengerId } from "../../types/primitiveTypes"
import type Price from "../../records/Price"
import type { PhaseType } from "../../consts/phase"
import type { Ancillaries, ExtrasId } from "../../types/bookingAncillary"
import { PARTNER_TYPES } from "../../consts/booking"

// @ts-expect-error: Flow to TS migration.
type State = Map<{
  loading: boolean
  ancillaries: Ancillaries
}>

type MessageParams = {
  action: null
  payload: null
  error: null
}

export type MessageInst = RecordOf<MessageParams>

type BookingStateParams = {
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any
  phase: PhaseType
  invalidating: boolean
  error: MessageInst | null | undefined
  success: MessageInst | null | undefined
  modal: string | null | undefined
}

export type InsuranceState = "done" | "processing"
export type BookingStateInst = RecordOf<BookingStateParams>

export type UsInsuranceAncillariesPassenger = {
  id: PassengerId
  isActive: boolean
  level: string
  price: Price
  universalId: string
}

export type UsCoverMoreInsuranceAncillaries = {
  id: ExtrasId
  extraId: ExtrasId
  state: InsuranceState
  refundExpiryDate: string
  passengers: UsInsuranceAncillariesPassenger[]
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const bidSelector = (state: any): number => Number(state.params.bookingId)
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ancillariesSelector: any = (state: any) => state.ancillaries.get("ancillaries")

// @ts-expect-error: Flow to TS migration.
export const usCoverMoreInsuranceSelector: OutputSelector<
  State,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  UsCoverMoreInsuranceAncillaries | null | undefined
  // @ts-expect-error: Flow to TS migration.
> = createSelector(ancillariesSelector, (ancillaries) => ancillaries?.usCoverMoreInsurance)

export const anyPaxWithInsurance = (passengers?: UsInsuranceAncillariesPassenger[] | null) => {
  if (!passengers || passengers.length === 0) return false
  return passengers.map((item) => item.isActive).includes(true)
}

// @ts-expect-error: Flow to TS migration.
export const anyPaxWithCoverMoreInsuranceSelector: OutputSelector<
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  boolean
> = createSelector([usCoverMoreInsuranceSelector], (coverMoreInsurance) =>
  anyPaxWithInsurance(coverMoreInsurance?.passengers),
)

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const anyPaxWithAxaUsInsuranceSelector: OutputSelector<any, any, boolean> = createSelector(
  [ancillariesSelector],
  (ancillaries) => {
    // Fix this the next time the file is edited. (Flow to TS)
    // @ts-expect-error: Flow to TS migration.
    // eslint-disable-next-line @typescript-eslint/array-type, @typescript-eslint/no-explicit-any
    const allPaxAxaUsInsurances = (ancillaries?.axaUsInsurance || []).reduce<Array<any>>(
      // @ts-expect-error: Flow to TS migration.
      (acc, axaUsInsurance) => acc.concat(...axaUsInsurance?.items),
      [],
    )
    return anyPaxWithInsurance(allPaxAxaUsInsurances)
  },
)

/** gets booking state */
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const bookingStateSelector = (state: any): BookingStateInst => state.booking
/** gets booking */
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const bookingDataSelector: InputSelector<any, undefined, any> = fp.compose(
  fp.get("data"),
  bookingStateSelector,
)

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isB2BPartnerTypeSelector: OutputSelector<any, any, boolean> = createSelector(
  bookingDataSelector,
  // @ts-expect-error: Flow to TS migration.
  (bookingData) => bookingData.partnerType === PARTNER_TYPES.B2B,
)
